import React from "react";

export const ActionBtn = ({ imgSource, title, btnColor, onClick }) => {
    return (
        <img
            src={imgSource}
            alt={title}
            title={title}
            height={26}
            width={26}
            style={{
                padding: "4px",
                backgroundColor: btnColor,
                borderRadius: "4px",
                cursor: "pointer",
            }}
            onClick={onClick}
        />
    );
};
